<template>
    <!-- 检测记录-查看报告-修改图片 -->
    <el-dialog
        title="修改图片"
        :visible.sync="dialogVisible"
        width="960px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        append-to-body
        :before-close="handleClose"
        top="8vh"
        custom-class="modify-img-pop"
    >
        <div
            v-loading="loading"
            class="modify-image-container"
            element-loading-text="拼命加载中"
            element-loading-background="rgba(255,255,255,0)"
        >
            <p class="modify-image-tip">
                *含有违禁词的图片被全部替换后，系统会默认此条产品<font class="red">不含有图片违禁词</font
                >，请确保替换后的图片不含有违禁词。
            </p>
            <div class="modify-image-top dfcjsb mt20 mb20">
                <p>检测标题：{{ row.subject }}</p>
                <div class="dfc mode">
                    <p class="tile-mode-btn" :class="{ active: mode === 1 }" @click="mode = 1">平铺模式</p>
                    <p class="list-mode-btn" :class="{ active: mode === 2 }" @click="mode = 2">列表模式</p>
                </div>
            </div>

            <div v-show="mode === 1" class="tile-mode">
                <modifyImageAsideBar
                    ref="mainImageFwAside"
                    :image-fw="mainImageFw"
                    :images="images"
                    @lookCheckResult="lookCheckResult"
                    @changeImg="changeImg"
                    @delImage="delImage"
                    @ignoreTips="ignoreTips"
                    @scroll2Img="scroll2Img"
                />
                <div class="dfcjsb mt10" style="height: 340px">
                    <modifyImageAsideBar
                        ref="detailImageFwAside"
                        style="overflow-y: auto; width: 220px"
                        :image-fw="detailImageFw"
                        @changeImg="changeImg"
                        :images="images"
                        @lookCheckResult="lookCheckResult"
                        @delImage="delImage"
                        @ignoreTips="ignoreTips"
                        @scroll2Img="scroll2Img"
                    />
                    <div
                        id="detail-content"
                        class="detail-content"
                        :class="{ ml60: detailImageFw.length === 0 }"
                        v-html="modifiedDescription"
                    ></div>
                </div>
            </div>
            <div v-show="mode === 2" class="list-mode">
                <el-table :data="tableData" style="width: 100%" :header-cell-style="tableHeader" max-height="550px">
                    <el-table-column label="位置" header-align="center" align="center" width="80">
                        <template #default="{ row }">
                            <p>{{ row.name }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="图片" header-align="center" align="center" width="90">
                        <template #default="{ row }">
                            <el-popover
                                popper-class="supply-pic-preview"
                                placement="right"
                                width="400"
                                trigger="hover"
                                :disabled="row.Url === ''"
                            >
                                <div
                                    class="modify-image-large-img"
                                    :style="{
                                        backgroundImage: `url(${row.Url === '' ? row.path : row.Url})`,
                                    }"
                                ></div>
                                <div
                                    slot="reference"
                                    class="detail-img"
                                    :style="{
                                        backgroundImage: `url(${row.Url === '' ? row.path : row.Url})`,
                                    }"
                                >
                                    <div v-if="row.Url === ''" class="tag">已删除</div>
                                </div>
                            </el-popover>
                        </template>
                    </el-table-column>
                    <el-table-column label="违禁词" header-align="center" align="center">
                        <template #default="{ row }">
                            <p :class="[row.Url != row.path && row.word != '无检测出违禁词' ? 'delthrough' : '']">
                                <span>{{ row.word == '无检测出违禁词' ? '否' : row.word }}</span
                                ><br />
                                <span v-if="row.ignore != 0 && row.word != '无检测出违禁词'">（已忽略）</span>
                            </p>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column
            label="是否含有方正字体"
            header-align="center"
            align="center"
            width="140"
          >
            <template v-slot="{ row }">
              <p :class="[row.Url != row.path && row.fontJudge == '是' ? 'delthrough' : '']">
                &nbsp;{{ row.fontJudge }}&nbsp;<em v-if="row.ignore != 0 && row.fontJudge == '是'"
                  >（已忽略）</em
                >
              </p>
            </template>
          </el-table-column> -->
                    <el-table-column label="状态" header-align="center" align="center" width="80">
                        <template #default="{ row }">
                            {{ row.ignore != 0 || row.Url != row.path ? '已处理' : '待处理' }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" header-align="center" align="center" width="300">
                        <template #default="{ row }">
                            <p class="dfcjs blue operation">
                                <span @click="lookCheckResult(row)">查看检测结果</span>
                                <!-- <span @click="changeImg(row)">更换图片</span> -->
                                <span @click="delImage(row)">删除图片</span>
                                <span @click="ignoreTips(row, row.name === '主图')">忽略</span>
                            </p>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <checkDetail ref="checkDetail" />
        </div>
        <div class="tr mt20">
            <el-button type="primary" size="small" @click="confirm">确 定</el-button>
        </div>
        <upload-photo ref="uploadPhoto" />
    </el-dialog>
</template>
<script>
import { cloneDeep } from 'lodash';
import checkDetail from './checkDetail';
import modifyImageAsideBar from './modifyImageAsideBar';
import uploadPhoto from '../../batchModify/components/UploadPhoto.vue';
export default {
    name: 'ModifyImage',
    components: { checkDetail, modifyImageAsideBar, uploadPhoto },
    props: {
        OfferStatu: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            dialogVisible: false,
            loading: false,
            row: {},
            mode: 1, // 模式： 1=>平铺模式；2=>列表模式
            mainImageFw: [],
            detailImageFw: [],
            images: [],
            productionInfo: {},
            modifiedDescription: '', // 原始详情
            nolongerShowTip: false,
            tableHeader: {
                background: '#ebecf1',
                color: '#4c4b4b',
                fontSize: '14px',
                fontWeight: 'normal',
            }, // 表头样式
        };
    },
    computed: {
        tableData({ images }) {
            const arr = images.filter((v) => v.ignore != 1);
            return arr;
        },
    },
    methods: {
        show(row, goods) {
            this.mode = 1;
            this.row = cloneDeep(row);
            this.handleData(row, goods);
            this.dialogVisible = true;
        },
        handleData(row) {
            if (row.mainImageFw) {
                this.mainImageFw = row.mainImageFw.filter((v) => !v.FwIgnore); // 过滤掉忽略的图片
                if (this.mainImageFw.length) {
                    this.$nextTick(() => {
                        this.$refs.mainImageFwAside.show('主图');
                    });
                }
            }
            if (row.detailImageFw) {
                this.detailImageFw = row.detailImageFw.filter((v) => !v.FwIgnore); // 过滤掉忽略的图片
                if (this.detailImageFw.length) {
                    this.$nextTick(() => {
                        this.$refs.detailImageFwAside.show('详情图');
                    });
                }
            }
            const images = [];
            let i = 0;
            const len = this.mainImageFw.length;
            for (; i < len; i++) {
                const item = this.mainImageFw[i];
                let allWordz;
                if (item.AllWord != undefined) {
                    // 兼容旧数据
                    allWordz = JSON.parse(item.AllWord);
                } else {
                    allWordz = item.WordsBlocks;
                }
                const oneWord = this.mainImageFw[i].FwWords.split('|'); // 违禁词信息
                let words = ''; // 累加文字
                let Fonts = ''; // 累加字体
                let fontJudge = '否'; // 是否有字体
                for (let x = 0; x < allWordz.length; x++) {
                    if (allWordz[x].ExistFwWord) {
                        for (let c = 0; c < oneWord.length; c++) {
                            const newWz1 = "<em class='red'>" + oneWord[c] + '</em><br/>';
                            const reg = new RegExp(`${oneWord[c]}`, 'ig');
                            words = words + allWordz[x].Words.replace(reg, newWz1);
                        }
                    } else {
                        words = words + allWordz[x].Words + '<br/>';
                    }
                    if (allWordz[x].Font == 'founder') {
                        Fonts = Fonts + "<em class='red upright'>" + allWordz[x].Words + '</em><br/>'; // 方正字体
                        fontJudge = '是';
                    } else {
                        Fonts = Fonts + allWordz[x].Words + '<br/>'; // 方正字体
                    }
                    if (allWordz[x].ExistFwFont == null) {
                        fontJudge = '未检测';
                    }
                }
                const arr = {
                    id: i,
                    offerIdStr: row.offerIdStr,
                    path: item.ImageUrl,
                    name: '主图',
                    value: '主图', // 阿里相册展示图片名称
                    word: item.ForbiddenWord == '' ? '无检测出违禁词' : item.ForbiddenWord,
                    fontJudge: fontJudge,
                    allWord: words,
                    allFont: Fonts,
                    ignore: item.FwIgnore != undefined && item.FwIgnore == true ? 1 : 0,
                    Url: item.ImageUrl,
                    Url64X64: item.ImageUrl,
                };
                images.push(arr);
            }
            const len2 = this.detailImageFw.length + len;
            for (let j = len; j < len2; j++) {
                let allWord;
                const item = this.detailImageFw[j - len];
                if (item.AllWord != undefined) {
                    // 兼容旧数据
                    allWord = JSON.parse(item.AllWord);
                } else {
                    allWord = item.WordsBlocks;
                }
                const oneWord = this.detailImageFw[j - len].FwWords.split('|'); // 这个是检测出来的一些违禁词
                let words = ''; // 累加文字
                let Fonts = ''; // 累加字体
                let fontJudge = '否'; // 是否有字体
                // 文字标红
                for (let z = 0; z < allWord.length; z++) {
                    if (allWord[z].ExistFwWord) {
                        for (let x = 0; x < oneWord.length; x++) {
                            const newWz = "<em class='red'>" + oneWord[x] + '</em><br/>'; // 先将检测出来的违禁词循环给每一个标红
                            const reg = new RegExp(`${oneWord[x]}`, 'ig');
                            allWord[z].Words = allWord[z].Words.replace(reg, newWz); // 最后一步就是将 标红的违禁词替换掉原来没有标红的，再 +加上正常的词语
                        }
                        words += allWord[z].Words;
                    } else {
                        words = words + allWord[z].Words + '<br/>';
                    }
                    if (allWord[z].Font == 'founder') {
                        Fonts = Fonts + "<em class='red upright'>" + allWord[z].Words + '</em><br/>';
                        fontJudge = '是';
                    } else {
                        Fonts = Fonts + allWord[z].Words + '<br/>';
                    }
                    if (allWord[z].ExistFwFont == null) {
                        fontJudge = '未检测';
                    }
                }
                const arr = {
                    id: j,
                    offerIdStr: row.offerIdStr,
                    path: item.ImageUrl,
                    name: '详情图',
                    value: '详图', // 阿里相册展示图片名称
                    word: item.ForbiddenWord == '' ? '无检测出违禁词' : item.ForbiddenWord,
                    fontJudge: fontJudge,
                    allWord: words,
                    allFont: Fonts,
                    ignore: item.FwIgnore != undefined && item.FwIgnore == true ? 1 : 0,
                    Url: item.ImageUrl,
                    Url64X64: item.ImageUrl,
                };
                images.push(arr);
            }
            this.images = images;
            this.$ajax.post('api/tiktok/Product/localdetail?productIdStr=' + row.offerIdStr).then((res) => {
                this.loading = false;
                this.productionInfo = JSON.parse(JSON.stringify(res.result));
                this.modifiedDescription = this.productionInfo.description;
            });
        },
        changeImg(item) {
            const imageList = cloneDeep(this.images);
            imageList[0].selected = false;
            try {
                imageList[item.id].selected = true;
            } catch {
                imageList[0].selected = true;
            }

            this.$refs.uploadPhoto.show({
                max: 1,
                cb: (urls) => {
                    imageList[item.id].Url = urls[0];
                    imageList[item.id].Url64X64 = urls[0];
                    this.images = imageList;
                    this.refreshDescription();
                },
            });
            // this.$refs.aliAlbum.show({
            //     list: imageList,
            //     chooseNum: imageList.length,
            //     confirm: (data) => {
            //         const arr = [];
            //         for (let i = 0, len = this.images.length; i < len; i++) {
            //             const item1 = this.images[i];
            //             const item2 = data[i];
            //             const obj = {};
            //             for (const key in item1) {
            //                 if (key === 'selected') {
            //                     continue;
            //                 }
            //                 obj[key] = item2[key];
            //             }
            //             if (obj.Url && !obj.Url.includes('http')) {
            //                 obj.Url = 'https://cbu01.alicdn.com/' + obj.Url;
            //             }
            //             obj.Url64X64 = obj.Url;
            //             arr.push(obj);
            //         }
            //         this.images = arr;
            //         this.refreshDescription();
            //     },
            // });
        },
        lookCheckResult(result) {
            this.$refs.checkDetail.show(result);
        },
        refreshDescription() {
            let description = this.productionInfo.description;
            for (let i = 0, len = this.images.length; i < len; i++) {
                const item = this.images[i];
                if (item.name === '详情图') {
                    if (item.Url === '') {
                        // 已删除
                        description = description.replace(item.path, '');
                    } else if (item.Url !== item.path) {
                        // 已更换
                        description = description.replace(item.path, item.Url);
                    }
                }
            }
            this.modifiedDescription = description;
        },
        delImage(item) {
            if (item.Url === '') {
                return;
            }
            this.$confirm('是否确定删除该图片？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
                .then(() => {
                    this.images[item.id].Url = '';
                    this.images[item.id].Url64X64 = '';
                    this.refreshDescription();
                })
                .catch(() => {});
        },
        ignoreTips(item, isMainImage = true) {
            const h = this.$createElement;
            // isMainImage: true->主图；false->详情图
            if (item.ignore === 0 && item.Url !== '') {
                const wjcIgnoreTips = localStorage.getItem('wjcIgnoreTips');
                if (wjcIgnoreTips) {
                    this.startIgnore(item, isMainImage);
                    return;
                }
                this.$msgbox({
                    dangerouslyUseHTMLString: true,
                    title: '提示',
                    message: h('div', { class: { font14: true } }, [
                        h('p', null, ['忽略后，默认当前图片已处理，将不会提示该图片含有违禁词']),
                        h(
                            'el-checkbox',
                            {
                                on: {
                                    change: (val) => {
                                        this.nolongerShowTip = val;
                                    },
                                },
                            },
                            ['下次不再提示']
                        ),
                    ]),
                    // message: (

                    //     <div class="font14">
                    //         <p>忽略后，默认当前图片已处理，将不会提示该图片含有违禁词</p>
                    //         <el-checkbox
                    //             on={{
                    //                 change: (val) => {
                    //                     this.nolongerShowTip = val;
                    //                 },
                    //             }}
                    //         >
                    //             下次不再提示
                    //         </el-checkbox>
                    //     </div>
                    // ),
                }).then(() => {
                    if (this.nolongerShowTip) {
                        localStorage.setItem('wjcIgnoreTips', 'ignoreTips20210326');
                    }
                    this.startIgnore(item, isMainImage);
                });
            }
        },
        startIgnore(item, isMainImage) {
            this.loading = true;
            const params = {
                offerId: item.offerIdStr,
                ImageUrl: item.Url, // 要忽略的图片
                IgnoreType: isMainImage ? 0 : 1, // 忽略图片类型 主图 = 0，详情 = 1
                PlanNo: this.row.planNo,
            };
            this.$ajax.post('api/tiktok/ForbiddenWordRecord/FwIgnore', params).then((res) => {
                this.images[item.id].ignore = 2;
                this.loading = false;
                if (res.code !== 200) {
                    this.$message.warning(res.msg);
                    return;
                }
                this.$message.success('忽略成功');
            });
        },
        scroll2Img(url) {
            try {
                document.querySelector(`.modify-image-container #detail-content img[src='${url}']`).scrollIntoView({
                    behavior: 'smooth',
                });
            } catch {
                // do nothing
            }
        },
        handleClose(done) {
            this.modifiedDescription = '';
            this.$emit('refresh');
            done();
        },
        confirm() {
            const mainImageFw = [];
            const detailImageFw = [];
            for (let i = 0, len = this.images.length; i < len; i++) {
                const item = this.images[i];
                if (item.name === '主图') {
                    if (item.path !== item.Url) {
                        mainImageFw.push({
                            OldImageUrl: item.path,
                            ImageUrl: item.Url,
                        });
                    }
                } else if (item.path !== item.Url) {
                    detailImageFw.push({
                        OldImageUrl: item.path,
                        ImageUrl: item.Url,
                    });
                }
            }
            if (mainImageFw.length === 0 && detailImageFw.length === 0) {
                this.dialogVisible = false;
                this.$emit('refresh');
                return;
            }
            const params = {
                offerId: this.row.offerIdStr,
                detailImageFw: detailImageFw.length ? detailImageFw : null,
                mainImageFw: mainImageFw.length ? mainImageFw : null,
                PlanNo: this.row.planNo,
            };
            this.loading = true;
            this.$ajax.post('api/tiktok/ForbiddenWordRecord/FwImageModify', params).then((res) => {
                this.loading = false;
                if (res.code !== 200) {
                    this.$message.warning(res.msg);
                    return;
                }
                this.$message.success('操作成功');
                this.dialogVisible = false;
                this.$emit('refresh');
            });
        },
    },
};
</script>
<style lang="scss">
.modify-img-pop {
    .el-dialog--scroll {
        max-height: fit-content !important;
    }
    .el-dialog__body {
        max-height: fit-content !important;
    }
}
</style>
<style lang="scss" scoped>
.modify-image-container {
    color: #666;
    .delthrough {
        text-decoration: line-through;
        color: #bfbfbf;
    }
    .red {
        color: #e91b00;
    }
    .blue {
        color: #0064c1;
    }
    .modify-image-tip {
        height: 35px;
        font: 12px '思源黑体';
        line-height: 35px;
        margin-top: 10px;
        color: #e56933;
        border: 1px solid #edd478;
        background-color: #fff6cb;
        text-align: left;
        text-indent: 20px;
    }
    .modify-image-top {
        p {
            line-height: 30px;
            height: 30px;
        }
        .mode {
            p {
                width: 80px;
                text-align: center;
                border: 1px solid #ebebeb;
                cursor: pointer;
                &.tile-mode-btn {
                    // 平铺模式
                    border-top-left-radius: 20px;
                    border-bottom-left-radius: 20px;
                }
                &.list-mode-btn {
                    border-top-right-radius: 20px;
                    border-bottom-right-radius: 20px;
                    border-left: none;
                }
                &.active {
                    background: #388eef;
                    color: #fff;
                }
            }
        }
    }
    .tile-mode {
        // height: 340px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .detail-content {
            width: 680px;
            height: 340px;
            overflow: auto;
            border: 1px solid rgb(172, 172, 172);
        }
    }
    .list-mode {
        .detail-img {
            width: 64px;
            height: 64px;
            display: block;
            position: relative;
            border: 1px solid #dddddd;
            background-position: center center;
            background-repeat: no-repeat;
            background-size: contain;
            background-color: #fff;
            .tag {
                width: 66px;
                height: 66px;
                position: absolute;
                top: 0;
                left: 0;
                background-color: rgba(0, 0, 0, 0.6);
                text-align: center;
                line-height: 65px;
                color: #ffffff;
            }
        }
        .operation {
            span {
                cursor: pointer;
                & + span {
                    margin-left: 10px;
                }
            }
        }
    }
}
.modify-image-large-img {
    width: 380px;
    height: 380px;
    padding: 3px;
    border: 1px solid #fd8a13;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    background-color: #fff;
}
</style>
